import React from "react"
const NotFound = () => {
    return(
        <>
            <h1>Not Found</h1>
            <p>The resource you were looking for wasn't found, check the address and try again.</p>
        </>
    );
}
export default NotFound;